import router from '@/router';

/**
 *
 * Criação do objecto de duplicação de um guião.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * editados na página é que serão enviados.
 *
 * @param {Object}  data
 *
*/
const create = data => {
    const route = router.currentRoute;

    const duplicate = {
        id: route.params.id,
        campaign_id: data.campaign
    };

    return duplicate;
};
const requiredFields = [
    { field: 'campaign', isRequiredOnEdit: false }
];
export {
    create,
    requiredFields
};